import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const SendChatIcon = (props: IconProps) => (
  <Icon width="30px" height="30px" viewBox="0 0 30 30" {...props}>
    <path d="M15 30c8.2843 0 15-6.7157 15-15 0-8.28427-6.7157-15-15-15C6.71573 0 0 6.71573 0 15c0 8.2843 6.71573 15 15 15Z" />
    <path
      fill="#fff"
      stroke="#fff"
      d="m10.3335 13 .94.94 3.06-3.0533v10.78h1.3333v-10.78l3.06 3.06.94-.9467-4.6666-4.66663L10.3335 13Z"
    />
  </Icon>
);

export default memo(SendChatIcon);
